import posthog, { type CaptureOptions, type CaptureResult } from "posthog-js";
import type { FeatureId } from "@brev-io/common/src/analytics/feature-catalog";
import type { AnalyticsEvent } from "./events";
import { withEventFeature } from "./event-features";

/** Event properties; `feature_id` overrides the event's mapped feature. */
export type ClientEventProperties = Record<string, unknown> & { feature_id?: FeatureId };

/**
 * BRE-9866: the one client capture. It stamps the event's feature from
 * `EVENT_FEATURES`, so code outside React (or before the providers) gets what
 * `useAnalytics().track` adds. The analytics pause needs no check here:
 * `posthog.init`'s `before_send` drops every event while it is on.
 */
export function captureProductClientEvent(
  eventName: AnalyticsEvent,
  properties?: ClientEventProperties,
  options?: CaptureOptions,
): CaptureResult | undefined {
  const props = withEventFeature(eventName, properties);
  // Forwards only the arguments given, so an event with no feature is captured exactly as before.
  /* eslint-disable no-restricted-properties -- the sanctioned capture every client event goes through */
  if (options !== undefined) return posthog.capture(eventName, props, options);
  return props === undefined ? posthog.capture(eventName) : posthog.capture(eventName, props);
  /* eslint-enable no-restricted-properties */
}
